export const ownerFieldsMapping = {
  'owner.user.name': ['owner.user.avatar', 'owner.user.initialColor'],
  'document.docId': ['id', 'document.id'],
};

export const cellOverflowFields = [
  'precalc.partNumberTitle',
  'precalc.partNumberDescription',
  'precalc.shippingItemsPart',
  'precalc.primarySiteContact',
  'precalc.siteAddress',
  'precalc.siteName',
  'formInput.customerName',
  'precalc.supplierCertifications',
  'precalc.supplierItemsProvided',
  'precalc.supplierType',
  'precalc.primaryContactName',
  'name',
  'document.docId',
];
